/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Signer_CreatorInputs */

const vi_sinp_signer_creator = /** @type {(inputs: Sinp_Signer_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NGƯỜI TẠO PHIẾU`)
};

/**

* @param {Sinp_Signer_CreatorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_signer_creator = /** @type {((inputs?: Sinp_Signer_CreatorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Signer_CreatorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_signer_creator(inputs)
});